export default class AnalyticsEvent {
    static init() {
        // Button Links
        document.addEventListener('click', e => {
            const target = e.target.closest('a[class*="analytics-track--"]');
            this.handleEvent(target, 'Button', 'Click')
        })

        // Forms
        setTimeout(() => {
            const formSuccessMessagesWithAnalyticsEventTracking = document.querySelectorAll('#form-success-message[class*="analytics-track--"]');
            formSuccessMessagesWithAnalyticsEventTracking.forEach(formSuccessMessageElement => {
                this.handleEvent(formSuccessMessageElement, 'Form', 'Submit');
                this.handleFormSubmission(formSuccessMessageElement)
            })
        }, 2000)
    }

    static handleEvent(el, eventCategory, eventAction) {
        if (!el) {
            return;
        }

        const eventName = this.getAnalyticsEvent(el);
        if (!eventName) {
            return;
        }

        window._paq?.push(['trackEvent', eventCategory, eventAction, eventName])
        window.dataLayer?.push({'event': eventCategory + '_' + eventAction + '_' + eventName})
    }

    static handleFormSubmission(el) {
        if (!el) {
            return;
        }

        const eventName = this.getAnalyticsEvent(el);
        if (!eventName) {
            return;
        }

        window._paq?.push(['FormAnalytics::trackFormConversion', eventName]);
    }

    static getAnalyticsEvent (el) {
        return [...el.classList].reduce((eventName, className) => {
            if (className.indexOf('analytics-track--') !== -1) {
                return className.replace('analytics-track--', '')
            }
            return eventName;
        }, null);
    }
}
